import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { SeismicProgramDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-seismic-program-container',
  templateUrl: './seismic-program-container.component.html',
  styleUrls: ['./seismic-program-container.component.scss'],
})
export class SeismicProgramContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  programs$: Observable<SeismicProgramDto[]>;
  loading: boolean;
  isLoadingProgram$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingProgram$ = this.gatwayFacade.isLoadingGateway(
      'SeismicProgram'
    );
    this.programs$ = this.gatwayFacade.loadGateway('SeismicProgram');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteProgram(deletedValue: any) {
    this.gatwayFacade.remove('SeismicProgram', deletedValue);
  }

  // this method control both the create and update

  onSubmitProgram(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Programs;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllProgram = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllProgram.push(pullData[i]);
      }
    }

    // check if the addAllProgram array is not empty, then dispatch the data to the store
    if (addAllProgram.length > 0) {
      this.gatwayFacade.add('SeismicProgram', addAllProgram);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('SeismicProgram', allUpdates, ['id']);
    }
  }
}
